import service from './api';
import { vocabulary } from '../constants/apiRoutes';
import { vocabularyKey } from '../constants/localStorageKeys';

export default 
{
  async getVocabulary() {
    return await service.getDataService(vocabulary, vocabularyKey);
  },
};